export default __webpack_public_path__ + "7fc878d4626fa73c847d8bf0e789128d.woff2";